import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import axios from "axios";
import debounce from "lodash.debounce";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { themecolors } from "../../Layout/theme";

const SearchDropdown = ({
  apiUrl,
  queryKey = "q",
  value,
  onChange,
  label = "Search",
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchData = async (searchText = "") => {
    setLoading(true);
    setError(null);

    try {
      const url = typeof apiUrl === "function" ? apiUrl(searchText) : apiUrl;
      const response = await axios.get(url, {
        params: typeof apiUrl === "function" ? {} : { [queryKey]: searchText },
      });
      const data = response.data?.data || [];
      setOptions(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Search API error:", err);
      setOptions([]);
      setError("Failed to load results");
    } finally {
      setLoading(false);
    }
  };

  const debouncedFetch = useMemo(() => debounce(fetchData, 400), []);

  useEffect(() => {
    fetchData();
    return () => {
      debouncedFetch.cancel();
    };
  }, [debouncedFetch]);

  const filter = createFilterOptions({
    stringify: (option) => `${option.contractNumber || ""} ${option.name || ""}`,
  });

  return (
    <Autocomplete
      size="small"
      options={options}
      value={value}
      onChange={(e, newValue) => {
        const matched = options.find((opt) => opt.id === newValue?.id) || null;
        onChange(matched);
      }}
      getOptionLabel={(option) =>
         option.name || ""
      }
      isOptionEqualToValue={(option, val) => option.id === val.id}
      filterOptions={filter}
      loading={loading}
      noOptionsText={error || "No options found"}
      onInputChange={(e, newValue, reason) => {
        if (reason === "input") {
          debouncedFetch(newValue);
        } else if (reason === "clear") {
          debouncedFetch.cancel();
          setOptions([]);
          fetchData();
        }
      }}
     renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          error={!!error}
          helperText={error}
          size="small" 
   sx={{
  "& .MuiInputLabel-root": {
    fontSize: 12,
       '&.Mui-focused': {
      color: themecolors['500'],
    },
  },

  "& .MuiOutlinedInput-root": {
    minHeight:30,
    borderRadius: 1,
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: themecolors['500'],
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "8px 8px", 
    fontSize: 12,
    lineHeight: 1.2,
    boxSizing: "border-box",
    borderColor: themecolors['500'],
    
  },
  "& .MuiOutlinedInput-notchedOutline": {
    borderRadius: 1,
  },
}}

          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading && <CircularProgress size={18} style={{color:themecolors['500']}}/>}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SearchDropdown;
